// import * as Sentry from '@sentry/react-native';

interface ExceptionProps {
  error?: string;
  file?: string;
  message?: string;
}

const logSentryException = ({ error, file, message }: ExceptionProps) => {
  if (__DEV__) {
    console.log(`Error:\n${error}\n- File:\n${file}\n- Message:\n${message}`);
  } else {
    // Sentry.withScope((scope) => {
    //   scope.setTag('File', file);
    //   scope.setTag('message', message);
    //   Sentry.captureException(error);
    // });
  }
};

export default logSentryException;
